import { fetchBusker, submitBusker } from '@/services/supabase-service';
import { Busker } from '@/types/type';
import { media_host } from '@/utils/const';
import { supabase } from '@/utils/supabase';
import { Image } from 'expo-image';
import * as ImagePicker from 'expo-image-picker';
import { router, useLocalSearchParams } from 'expo-router';
import { useEffect, useState } from 'react';
import {
  Button,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';

const BuskerDetailsScreen = () => {
  const [busker, setBusker] = useState<Busker | null>(null);
  const [images, setImages] = useState<ImagePicker.ImagePickerAsset[]>([]);
  const { busker_id: busker_id } = useLocalSearchParams<{ busker_id: string }>();

  useEffect(() => {
    const fetchData = async () => {
      const selectedBusker = await fetchBusker(busker_id);
      setBusker(selectedBusker);
    };
    fetchData();
  }, [busker_id]);

  const handleSave = async () => {
    if (!busker) {
      return;
    }

    for (const image of images) {
      const user_id = (await supabase.auth.getSession()).data.session?.user?.id;
      const arraybuffer = await fetch(image.uri).then((res) => res.arrayBuffer());
      const path = `${user_id}/${Date.now()}-${image.fileName}`;
      console.log('Uploading image to:', path);
      const { data, error: uploadError } = await supabase.storage
        .from('media')
        .upload(path, arraybuffer, {
          contentType: image.mimeType ?? 'image/jpeg',
        });
      if (uploadError) {
        throw uploadError;
      }
      console.log('Uploaded image:', data);
      busker.media_urls = [
        ...(busker.media_urls || []),
        { url: media_host + path, source: 'cdn', type: 'image' },
      ];
    }

    submitBusker(busker);

    router.back();
  };

  const pickImage = async () => {
    // No permissions request is necessary for launching the image library
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ['images', 'videos'],
      allowsMultipleSelection: true,
      allowsEditing: false,
    });

    console.log(result);
    if (!result.canceled) {
      setImages([...images, ...result.assets]);
    }
  };

  if (!busker) {
    return <Text>Loading...</Text>;
  }

  return (
    <ScrollView style={styles.container}>
      <View style={styles.formContainer}>
        <TextInput
          style={styles.input}
          placeholder="Busker Name"
          value={busker.full_name}
          onChangeText={(text) => setBusker({ ...busker, full_name: text })}
        />

        <TextInput
          style={styles.input}
          placeholder="Description"
          value={busker.description}
          onChangeText={(text) => setBusker({ ...busker, description: text })}
          multiline
          numberOfLines={4}
        />

        <TextInput
          style={styles.input}
          placeholder="Email"
          value={busker.email}
          onChangeText={(text) => setBusker({ ...busker, email: text })}
          keyboardType="email-address"
        />
        <Button title="Add photos" onPress={pickImage}></Button>
        <TouchableOpacity style={styles.button} onPress={handleSave}>
          <Text style={styles.buttonText}>Save Changes</Text>
        </TouchableOpacity>
        <View className="mt-4 w-full">
          {images.map((item, index) => (
            <View key={index}>
              <Text>
                {item.fileName} {index}
              </Text>
              <Image source={{ uri: item.uri }} className="w-full h-[250px]" contentFit="contain" />
            </View>
          ))}
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  formContainer: {
    padding: 16,
  },
  input: {
    borderWidth: 1,
    borderColor: '#ddd',
    borderRadius: 8,
    padding: 12,
    marginBottom: 16,
    fontSize: 16,
  },
  button: {
    backgroundColor: '#007AFF',
    padding: 16,
    borderRadius: 8,
    alignItems: 'center',
  },
  buttonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
});

export default BuskerDetailsScreen;
